import React, { useEffect } from "react";
import styles from "./AssignTaskConfirmation.module.css";
import ModalView from "@modals/modalview/ModalView";
import confirmationIcon from "@assets/icons/confirmation-icon.svg";
import closeIcon from "@assets/icons/close-icon.svg";
interface AssignTaskConfirmationProps {
  isOpen: boolean;
  onStartEvaluation: () => void;
  onClose: () => void;
}
function AssignTaskConfirmation({
  isOpen,
  onStartEvaluation,
  onClose,
}: AssignTaskConfirmationProps) {
  useEffect(() => {
    if (!isOpen) return;
  }, [isOpen]);

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.closeHeader}>
          <button className={styles.closeBtn} onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
        <img src={confirmationIcon} className={styles.confirmationIcon} />
        <div className={styles.headingtext}>Confirm Task Assignment</div>
        <p>
          Your task will be marked complete only after you finish evaluating all
          assigned questions for this student.
        </p>
        <div className={styles.btnContainer}>
          <button
            className={styles.startEvaluationBtn}
            onClick={onStartEvaluation}
          >
            Start Evaluation
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default AssignTaskConfirmation;
